/** @file Index of a sheet name in `Object.keys(puppet.sheets)` (the `sheet` slot). */
import type { Puppet } from '@zilo/pose3d-format/types/puppet';
import { throwError } from '@zilo/pose3d-std/errors/throwError';
import { RENDER_CORE_ERRORS } from '@zilo/pose3d-render-core/errors/renderCoreErrors';

/** The key-order index of `sheet`; throws `SHEET_UNKNOWN` when the puppet has no such sheet. */
export function sheetIndexOf(puppet: Puppet, sheet: string): number {
  const i = Object.keys(puppet.sheets).indexOf(sheet);
  return i < 0 ? throwError(RENDER_CORE_ERRORS.SHEET_UNKNOWN, { sheet }, { hint: Object.keys(puppet.sheets).join(', ') }) : i;
}
